<template>
    <div>
        <h1 class="subtitle">Renovar Stock</h1>
        <hr />
        <b-table :data="data" :loading="loading" paginated backend-pagination bordered :total="total" :per-page="perPage" aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Pág." aria-current-label="Pág. actual" checkable :checked-rows.sync="checkedRows" @page-change="onPageProductoChange">
            <template slot-scope="props">
                <b-table-column label="Almacen">
                    {{ props.row.inventario_id.almacen.descripcion }}
                </b-table-column>
                <b-table-column label="Producto">
                    {{ props.row.inventario_id.producto_variacion.producto_variacion_id.producto.nombre }}
                </b-table-column>
                <b-table-column label="Unidad">
                    {{ props.row.inventario_id.producto_variacion.unidad.simbolo }}
                </b-table-column>
                <b-table-column label="Marca">
                    {{ props.row.inventario_id.producto_variacion.producto_variacion_id.producto.marca.descripcion }}
                </b-table-column>
                <b-table-column label="Stock Minimo">
                    {{ props.row.stock_minimo }}
                </b-table-column>
                <b-table-column label="Stock Digital">
                    {{ props.row.stock_digital }}
                </b-table-column>
            </template>
            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>No se encontraron productos con falta de stock</p>
                    </div>
                </section>
            </template>
        </b-table>
        <table class="table is-bordered is-fullwidth" v-if="checkedRows.length > 0">
            <thead>
                <tr>
                    <th>Almacen</th>
                    <th>Producto</th>
                    <th>Unidad</th>
                    <th>Marca</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in checkedRows" :key="index + '_row'">
                    <td>
                        {{ item.inventario_id.almacen.descripcion }}
                    </td>
                    <td>
                        {{ item.inventario_id.producto_variacion.producto_variacion_id.producto.nombre }}
                    </td>
                    <td>
                        {{ item.inventario_id.producto_variacion.unidad.simbolo }}
                    </td>
                    <td>
                        {{ item.inventario_id.producto_variacion.producto_variacion_id.producto.marca.descripcion }}
                    </td>
                    <td>
                        <b-button :key="index + '_button'" type="is-danger" icon-right="delete" @click="deleteProductSelected(index)" />
                    </td>
                </tr>
            </tbody>
        </table>
        <b-button type="is-success" @click.prevent="loadOrdenWithProducts()" :disabled="checkedRows.length === 0">Generar Orden</b-button>
    </div>
</template>

<script>
import axios from "axios"
import { mapMutations } from "vuex"
export default {
    name: "RenovateStock",
    data() {
        return {
            data: [],
            perPage: 10,
            total: 0,
            loading: false,
            checkedRows: [],
            page: 1
        }
    },
    methods: {
        ...mapMutations("product", ["addList"]),
        onPageProductoChange(page) {
            this.page = page
            this.loadDataTable()
        },
        loadDataTable() {
            this.loading = true
            axios.post("/inventario/pending", {
                start: (this.page - 1) * this.perPage,
                length: this.perPage
            }).then(response => {
                this.data = response.data.data
                this.total = response.data.total
                this.loading = false
            })
        },
        deleteProductSelected(index) {
            this.checkedRows.splice(index, 1)
        },
        loadOrdenWithProducts() {
            this.addList(this.checkedRows)
            this.$router.push({ path: '/orden/new' })
        }
    },
    mounted() {
        this.loadDataTable()
    }
}
</script>

<style scoped></style>
